import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { CourseProgressSummary, UnitProgress } from '../data/student-report';
import { Course } from '../data/course';
import { FormatUtilities } from '../utilities/format-utilities';

@Component({
  selector: 'app-student-progress-report-kinder',
  templateUrl: './student-progress-report-kinder.component.html',
  styleUrls: ['./student-progress-report-kinder.component.scss']
})

export class StudentProgressReportKinderComponent extends BaseComponent implements OnInit {
  @Input() currentCourse: CourseProgressSummary;
  @Input() studentId: number;
  @Input() courses: Course[];

  displayTimeWithoutSeconds = FormatUtilities.displayTimeWithoutSeconds;
  longDateFormat = FormatUtilities.longDateFormat;

  selectedUnitNumber: number;

  ngOnInit(): void {

    // does this initialize every time this is activated?
    this.selectedUnitNumber = this.highestCompletedUnitInCurrentCourse || 1;
  }

  getUnitCircleClasses(unit: UnitProgress) {
    const classes = ['unit-circle'];
    if (unit.CompletedActivityCount === 0) {
      classes.push('unstarted');
    }
    else if (unit.UnitNumber < this.highestCompletedUnitInCurrentCourse || unit.UnitTested === true) {
      classes.push('completed');
    }
    else {
      classes.push('in-progress');
    }

    if (unit.CompletedActivityCount > 0) {
      classes.push('pointer');
    }

    if (unit.UnitNumber === this.selectedUnitNumber) {
      classes.push('selected');
    }
    return classes;
  }

  get highestCompletedUnitInCurrentCourse(): number {
    var highestUnit = this.currentCourse.Units.slice().reverse().find(u => u.CompletedActivityCount > 0);
    return highestUnit ? highestUnit.UnitNumber : 0;
  }

  selectUnit(unit: UnitProgress, initial = false): void {
    if (unit && (initial || unit.CompletedActivityCount !== 0)) {
      this.selectedUnitNumber = unit.UnitNumber;
    }
  }
}
